export enum CompanyDetailsTabEvents {
  AfterSave = 'save-company-details',
  Cancel = 'cancel-company-details',
}
